module.exports = __webpack_public_path__ + "img/other.39f004d6.png";